<form *ngIf="enterOTPFG" class="form digit-group" #form="ngForm" [formGroup]="enterOTPFG" (ngSubmit)="validateOTP(form)"
  novalidate>
  <div class="otp-screeb text-center">
    <!--    <span style='color: #9d9999;'>We have sent OTP via SMS to {{ currentUser?.mobilePhoneAreaCode }} **** {{ currentUser?.mobilePhoneNumber.substr(4, 7) }}</span>-->
    <span style="color: #3c3c3c" [hidden]="resendingVerificationCodes">
      {{ translate.currentLang === 'en' ? 'OTP has been sent to your mobile number' : 'OTP আপনার মোবাইল নম্বরে পাঠানো
      হয়েছে' }} {{ otpSendResponse?.mobile }} {{ translate.currentLang === 'en' ? 'and your email' : 'এবং আপনার ইমেইলে'
      }} {{ otpSendResponse?.email }}
    </span>
    <!--    <p class="text-center">OTP sent to {{ currentUser?.mobilePhoneAreaCode }}******</p>-->

    <div formGroupName="otp" class="otp-v-view mt-2 form-group text-center">
      <div class="otp_screen m-auto">
        <input #otpPin1Row formControlName="pin1" autocomplete="off" name="pin1" type="text" pattern="[0-9]*"
          tabindex="1" maxlength="1" (keydown)="restrictInput($event, 0)" (input)="validateInput($event, 0, 'pin1')" />
        <input #otpPin2Row formControlName="pin2" autocomplete="off" name="pin2" type="text" pattern="[0-9]*"
          tabindex="2" maxlength="1" (input)="validateInput($event, 1, 'pin2')" (keydown)="restrictInput($event, 1)" />
        <input #otpPin3Row formControlName="pin3" autocomplete="off" name="pin3" type="text" pattern="[0-9]*"
          tabindex="3" maxlength="1" (input)="validateInput($event, 2, 'pin3')" (keydown)="restrictInput($event, 2)" />
        <input #otpPin4Row formControlName="pin4" autocomplete="off" name="pin4" type="text" pattern="[0-9]*"
          tabindex="4" maxlength="1" (input)="validateInput($event, 3, 'pin4')" (keydown)="restrictInput($event, 3)" />
        <errors [on]="
            ((enterOTPFG.get('otp').get('pin1').touched || enterOTPFG.submitted) && enterOTPFG.get('otp').get('pin1').invalid) ||
            ((enterOTPFG.get('otp').get('pin2').touched || enterOTPFG.submitted) && enterOTPFG.get('otp').get('pin2').invalid) ||
            ((enterOTPFG.get('otp').get('pin3').touched || enterOTPFG.submitted) && enterOTPFG.get('otp').get('pin3').invalid) ||
            ((enterOTPFG.get('otp').get('pin4').touched || enterOTPFG.submitted) && enterOTPFG.get('otp').get('pin4').invalid)
          ">
          {{ translate.currentLang === 'en' ? 'Required' : 'আবশ্যক' }}
        </errors>
        <div [hidden]="!otpErrorMassage">
          <errors [on]="otpErrorMassage"> {{ otpErrorMassage }} </errors>
        </div>

      </div>
      <div class="d-flex justify-content-between align-items-center otp-row">

        <!-- Verify Button -->
        <app-primary-button [text]="translate.currentLang === 'en' ? 'Verify & Continue' : 'যাচাই করুন এবং চালিয়ে যান'"
          [loading]="otpVerifying" type="submit" [fullWidth]="true" class="verify-btn">
        </app-primary-button>

        <!-- Resend Button -->
        <button class="resend-btn" (click)="sendOtp()" [disabled]="resendingVerificationCodes">
          {{ translate.currentLang === 'en' ? 'Resend OTP' : 'OTP পুনরায় পাঠান' }}
          <span class="loader inline-loader ms-1" [hidden]="!resendingVerificationCodes"></span>
        </button>

      </div>
    </div>
  </div>
</form>